export const RECEIPTS_CUSTOM_QUERY = {
  ReceiptsWithReview: 'ReceiptsWithReview',
  ReceiptsWithComments: 'ReceiptsWithComments',
  ReceiptsWithoutComment: 'ReceiptsWithoutComment',
  ReceiptsWithReviewWithoutComment: 'ReceiptsWithReviewWithoutComment',
  ReceiptsWithCommentWithoutReply: 'ReceiptsWithCommentWithoutReply',
};

export const USER_BRANDS_CUSTOM_QUERY = {
  OrderByLastReceipt: 'OrderByLastReceipt',
};

export const JPG_MIME_TYPE = 'image/jpeg';
export const PNG_MIME_TYPE = 'image/png';
export const GIF_MIME_TYPE = 'image/gif';
export const PDF_MIME_TYPE = 'application/pdf';

export const IMAGE_MIME_TYPES = [
  JPG_MIME_TYPE,
  PNG_MIME_TYPE,
  GIF_MIME_TYPE,
];

export const ALLOW_RECEIPT_MIME_TYPE = [
  ...IMAGE_MIME_TYPES,
  PDF_MIME_TYPE,
];

export const SOCIAL_NETWORK = {
  FACEBOOK: 'https://www.facebook.com/Clean-Bill-456436591597926',
};

export const STORES = {
  GOOGLE_PLAY_STORE: 'https://play.google.com/store/apps/details?id=fr.cleanbill.app',
  APPLE_APP_STORE: 'https://apps.apple.com/fr/app/cleanbill/id1489330321',
};

export const AUTH_TOKEN_ACCESS = 'cleanbill-auth-token-access';
export const REFRESH_TOKEN = 'cleanbill-refresh-token';
export const CURRENT_USER = 'cleanbill-current-user';
export const ERROR_AUTH = 'cleanbill-current-user';
export const ERROR_TYPE_INTERNAL_ERROR = 'InternalError';
export const ERROR_TYPE_NOT_AUTHORIZED_ERROR = 'AuthError';
export const ERROR_TYPE_EMAIL_ALREADY_USED = 'EmailAlreadyUsedError';
export const ERROR_TYPE_PHONE_ALREADY_USED = 'PhoneAlreadyUsedError';
export const ERROR_TYPE_DEACTIVATED_ACCOUNT = 'DeactivatedAccountError';
export const ERROR_TYPE_FILE_SIZE_ERROR = 'FileSizeError';
export const ERROR_TYPE_AUTH_ERROR = 'AuthError';
export const ERROR_TYPE_INACTIVE_ACCOUNT = 'InactiveAccountError';
export const ERROR_TYPE_CHECKOUT_EXISTS = 'existingSerial';
export const ERROR_TYPE_BAD_REQUEST = 'BadRequestError';
export const PASSWORD_MAX_LENGTH = 6;
export const ROLES = {
  USER: 'User',
  MERCHANT: 'Merchant',
  ADMIN: 'Admin',
  CENTRAL_PURCHASING: 'CentralPurchasing',
};

export const CIVILITIES = [
  'Mr',
  'Mrs',
  'Other',
];

export const MERCHANT_TYPE = {
  Independent: 'Independent',
  Franchised: 'Franchised',
  Integrated: 'Integrated',
};

export const ISPRO_TYPE = {
  All: 'all',
  Yes: 'true',
  No: 'false',
};

export const ORDER_DIRECTION = {
  ASC: 'Ascending',
  DESC: 'Descending',
};

export const FILTER_OPERATOR = {
  Like: 'Like',
  GreaterThan: 'GreaterThan',
  LessThan: 'LessThan',
  Equal: 'Equal',
};

export const FILTER_EXPRESSION_OPERATOR = {
  And: 'And',
  Or: 'Or',
};

export const COLORS = {
  MAIN_PINK: '#c9005f',
  DARK_PINK: '#ab0051',
  PURPLE: '#5a126f',
  PURPLE_DARK: '#5a5a86',
  PURPLE_HEADER: '#595A88',
  PURPLE_DARKER: '#5a116d',
  PURPLE_TEXT: '#570231',
  PURPLE_PALE: '#7273a2',
  PURPLE_PALE_DARK: '#3b3a59',
  MAIN_BLACK: '#323232',
  BLACK: '#000',
  WHITE: '#FFF',
  GRAY: '#72818e',
  DARK_GRAY: '#3f3f3f',
  BACKGROUND_GRAY: '#dedeea',
  TRANSPARENT: 'transparent',
  BLUE: '#329aef',
  PINK_TAG: '#C7005F',
  SELECT_GRAY: 'rgba(72,72,72,0.6)',
  SELECT_BLACK: 'rgb(72,72,72)',
  SEARCH_BLACK: 'rgb(72,72,72,0.6)',
};

export const BADGE_COLORS = {
  GREEN: '#20c997',
  BLUE: '#1565c0',
  RED: '#c62828',
  ORANGE: '#ff8a50',
  GREY: '#9191b6',
};

export const THEMES = {
  ADMIN: 'ADMIN',
  MERCHANT: 'MERCHANT',
  USER: 'USER',
};

export const FILE_TYPE = {
  PDF: 'application/pdf',
};

export const RATING_RANGE = {
  START: 1,
  END: 5,
};

export const USER_BRANDS_ORDER_BY = {
  BRAND_NAME: 'brandName',
  LAST_RECEIPT: 'lastReceipt',
};

export const INVOICE_STATUS = {
  DRAFT : 'draft',
  OPEN : 'open',
  PAID : 'paid',
  UNCOLLECTIBLE : 'uncollectible',
  VOID : 'void',
};

export const PRODUCTS_TYPE = {
  NOTIFICATION: 'notification',
};

export const BILLING_SUBSCRIPTION_STATUS = {
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
};

export const BILLING_SUBSCRIPTION_PLAN_INTERVAL = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};

export const PAYMENT_INTENT_STATUS = {
  REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
  REQUIRES_CONFIRMATION: 'requires_confirmation',
  REQUIRES_ACTION: 'requires_action',
  PROCESSING: 'processing',
  REQUIRES_CAPTURE: 'requires_capture',
  CANCELED: 'canceled',
  SUCCEEDED: 'succeeded',
};

export const BILLING_SUBSCRIPTION_COLLECTION_METHOD = {
  CHARGE_AUTOMATICALLY: 'charge_automatically',
  SEND_INVOICE: 'send_invoice',
};

export const BILLING_SUBSCRIPTION_PLAN_BILLING_SCHEME = {
  PER_UNIT: 'per_unit',
  TIERED: 'tiered',
};

export const RANGE_CHART = {
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
};

export const START_YEAR = 2019;

export const CAMPAIGN_STATUS = {
  CREATED: 'Created',
  STARTED: 'Started',
  ENDED: 'Ended',
  CANCELED: 'Canceled',
};

export const MAX_CAMPAIGN_TITLE_LENGTH = 33;
export const MAX_CAMPAIGN_CONTENT_LENGTH = 125;
export const CAMPAIGN_PICTURE_WIDTH = 400;
export const CAMPAIGN_PICTURE_HEIGHT = 150;

export const BILLING_SUBSCRIPTION_CANCEL_AT = {
  PERIOD_END: 'PeriodEnd',
  NOW: 'Now',
};
